module.exports = __webpack_public_path__ + "media/assets/images/flags/al-3cb976443d1997a50c69bede4567a55d.svg";